import clsx from 'clsx';
import Store from '../Store';
import * as React from 'react';
import { activeComp } from './Types';
import { observer } from 'mobx-react';
import CompetencyStore from './Store';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { fromNullable } from 'maybeasy';
import { emptyFragment } from '../../../../../../../../../../../../../EmptyFragment';

export interface Props {
  store: Store;
  competencyStore: CompetencyStore;
}

const Left: React.FC<Props> = ({ store, competencyStore }) => {
  const handleClickScroll = (id: number) => {
    competencyStore.updateCompetencyId(id);
    const element = document.getElementById(String(id));
    fromNullable(element).map((element) => element.scrollIntoView({ behavior: 'smooth' }));
  };

  return (
    <div
      className="max-h-[54vh] basis-4/12 overflow-y-auto lg:overflow-x-hidden"
      data-intercom-target="competency-list"
    >
      {store.resource.payload.competencies.map((comp) => (
        <p
          onClick={() => handleClickScroll(comp.payload.id)}
          key={`left-${comp.payload.id}`}
          className={clsx(
            'block w-max px-2 py-1 mb-4 last:mb-0',
            'rounded-md border border-gray-900 text-gray-900',
            'text-xs font-medium tracking-tight break-keep',
            'cursor-pointer',
            activeComp(competencyStore.state, comp.payload.id),
          )}
        >
          {comp.payload.name
            .map((name) => <AlreadyTranslated content={name} />)
            .getOrElse(emptyFragment)}
        </p>
      ))}
    </div>
  );
};

export default observer(Left);
